import { loader } from 'graphql.macro'

export default async function createUser ({ dataLoaders, variables }) {
  const schema = loader('./createUser.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      userFields: variables
    }
  })
  return response.createUser
}
